import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
    Button, Card, CardBody, Col, Container, Input, Label,
    Modal, ModalBody, ModalFooter, ModalHeader, Row, Table,
} from "reactstrap"
import { StorageImage } from "@aws-amplify/ui-react-storage"

import BuildGuild from "./build-guild"

import {
    getAreas, updateArea,
    getUserGuilds, createUserGuild, deleteUserGuild,
} from "../../store/goals/actions"
import { getProfile } from "../../store/auth/profile/actions"

const PlantsGuild = (props) => {
    const {
        userGuilds, userareas, profile,
        onGetProfile, onGetAreas,
        onGetUserGuilds, onCreateUserGuild, onDeleteUserGuild, onUpdateArea,
    } = props

    const username = JSON.parse(localStorage.getItem("user") || "{}").user || ""

    const [showWizard, setShowWizard]         = useState(false)
    const [deployModal, setDeployModal]       = useState(false)
    const [deployGuild, setDeployGuild]       = useState(null)
    const [deployAreaId, setDeployAreaId]     = useState("")
    const [deployError, setDeployError]       = useState("")
    const [deleteModal, setDeleteModal]       = useState(false)
    const [deleteGuild, setDeleteGuild]       = useState(null)

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"))
        if (user) onGetProfile(user.user)
        onGetAreas()
        onGetUserGuilds()
    }, [])

    // Called by BuildGuild wizard when the user finishes
    function handleSaveGuild(guildData) {
        onCreateUserGuild(guildData)
    }

    function openDeployModal(guild) {
        setDeployGuild(guild)
        setDeployAreaId("")
        setDeployError("")
        setDeployModal(true)
    }

    function deployToArea() {
        if (!deployAreaId) { setDeployError("Please select an area."); return; }
        const area = userareas.find(a => a.id === deployAreaId)
        if (!area) return;

        const allPlants = [deployGuild.starPlayer, ...deployGuild.guildPlants].map(p => ({ ...p }))
        const updatedGuilds = { ...(area.guilds || {}), [deployGuild.guildName]: allPlants }
        onUpdateArea({ ...area, plants: [...area.plants, ...allPlants], guilds: updatedGuilds })
        setDeployModal(false)
    }

    if (showWizard) {
        return (
            <div className="page-content">
                <Container fluid>
                    <button type="button" className="btn btn-sm mb-3" style={{ backgroundColor: "#fff", borderColor: "#d1d5db", color: "#212529" }} onClick={() => setShowWizard(false)}>
                        ← Back to Guilds
                    </button>
                    <BuildGuild
                        profile={profile}
                        currArea={{ name: "", plants: [], guilds: {} }}
                        onSaveGuild={handleSaveGuild}
                        finishWizard={() => setShowWizard(false)}
                    />
                </Container>
            </div>
        )
    }

    return (
        <div className="page-content">
            <Container fluid>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
                    <h4 style={{ margin: 0 }}>Plant Guilds</h4>
                    <button type="button" className="btn btn-sm" style={{ backgroundColor: "#FF9900", borderColor: "#FF9900", color: "#fff" }} onClick={() => setShowWizard(true)}>
                        + New Guild
                    </button>
                </div>

                {userGuilds.length === 0 && (
                    <Card><CardBody><p className="text-muted mb-0">No guilds yet. Click New Guild to build one.</p></CardBody></Card>
                )}

                {userGuilds.map(guild => (
                    <Card key={guild.id} className="mb-3">
                        <CardBody>
                            <Row className="align-items-start">
                                <Col md={3}>
                                    <h5>{guild.guildName}</h5>
                                    <p className="text-muted small mb-2">
                                        {[guild.starPlayer, ...(guild.guildPlants || [])].length} plants
                                    </p>
                                    <button style={{backgroundColor: "#BEC8B6", color: "#000", border: "1px solid #545a6d", borderRadius: "4px", padding: "4px 8px", cursor: "pointer", marginRight: "6px"}} onClick={() => openDeployModal(guild)}>
                                        <span style={{color: "#000"}}>Deploy to Area</span>
                                    </button>
                                    <button style={{backgroundColor: "#BEC8B6", color: "#000", border: "1px solid #545a6d", borderRadius: "4px", padding: "4px 8px", cursor: "pointer"}} onClick={() => { setDeleteGuild(guild); setDeleteModal(true); }}>
                                        <span style={{color: "#000"}}>Delete</span>
                                    </button>
                                </Col>
                                <Col md={3}>
                                    {guild.imageKey && (
                                        <StorageImage
                                            imgKey={guild.imageKey}
                                            accessLevel="guest"
                                            style={{ width: "200px" }}
                                            onStorageGetError={(e) => console.error(e)}
                                        />
                                    )}
                                </Col>
                                <Col md={6}>
                                    <Table size="sm" responsive striped className="mb-0">
                                        <thead style={{ backgroundColor: "#BEC8B6" }}>
                                            <tr>
                                                <th>#</th>
                                                <th>Plant</th>
                                                <th>Size</th>
                                                <th>Functions</th>
                                                <th>Layer</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {[guild.starPlayer, ...(guild.guildPlants || [])].filter(Boolean).map((p, i) => (
                                                <tr key={i}>
                                                    <td>{p.numPlants}</td>
                                                    <td>{p.name || p.species}{i === 0 && <span className="badge bg-warning ms-1">Star</span>}</td>
                                                    <td>{p.size}</td>
                                                    <td>{Array.isArray(p.guildFunction) ? p.guildFunction.join(", ") : p.guildFunction}</td>
                                                    <td>{Array.isArray(p.foodForestLayer) ? p.foodForestLayer.join(", ") : p.foodForestLayer}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                ))}
            </Container>

            {/* Delete confirm modal */}
            <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)}>
                <ModalHeader toggle={() => setDeleteModal(false)}>Delete Guild</ModalHeader>
                <ModalBody>
                    Are you sure you want to delete <strong>{deleteGuild?.guildName}</strong>? This cannot be undone.
                </ModalBody>
                <ModalFooter>
                    <button style={{backgroundColor: "#BEC8B6", color: "#000", border: "1px solid #545a6d", borderRadius: "4px", padding: "4px 8px", cursor: "pointer", marginRight: "6px"}}
                        onClick={() => { onDeleteUserGuild(deleteGuild.id); setDeleteModal(false); }}>
                        <span style={{color: "#000"}}>Delete</span>
                    </button>
                    <button style={{backgroundColor: "#BEC8B6", color: "#000", border: "1px solid #545a6d", borderRadius: "4px", padding: "4px 8px", cursor: "pointer"}}
                        onClick={() => setDeleteModal(false)}>
                        <span style={{color: "#000"}}>Cancel</span>
                    </button>
                </ModalFooter>
            </Modal>

            {/* Deploy to Area modal */}
            <Modal isOpen={deployModal} toggle={() => setDeployModal(false)}>
                <ModalHeader toggle={() => setDeployModal(false)}>
                    Deploy "{deployGuild?.guildName}" to Area
                </ModalHeader>
                <ModalBody>
                    <Label>Select Area</Label>
                    <Input type="select" value={deployAreaId} onChange={e => { setDeployAreaId(e.target.value); setDeployError(""); }}>
                        <option value="">— choose an area —</option>
                        {userareas.filter(a => a.name !== "Unassigned" && a.year === new Date().getFullYear()).map(a => (
                            <option key={a.id} value={a.id}>{a.name}</option>
                        ))}
                    </Input>
                    {deployError && <p className="text-danger mt-2 mb-0">{deployError}</p>}
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-sm" style={{ backgroundColor: "#FF9900", borderColor: "#FF9900", color: "#fff" }} onClick={deployToArea}>Deploy</button>
                    <button type="button" className="btn btn-sm" style={{ backgroundColor: "#fff", borderColor: "#d1d5db", color: "#212529" }} onClick={() => setDeployModal(false)}>Cancel</button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

const mapStateToProps = (state) => ({
    userGuilds: Array.isArray(state.goals.userGuilds) ? state.goals.userGuilds : [],
    userareas: (state.goals.areas || [])
        .map(area => { const c = structuredClone(area); c.plants = c.plants.filter(p => p.species); return c; })
        .sort((a, b) => a.name.localeCompare(b.name)),
    profile: state.Profile.user,
})

const mapDispatchToProps = (dispatch) => ({
    onGetProfile: (username) => dispatch(getProfile(username)),
    onGetAreas: () => dispatch(getAreas()),
    onUpdateArea: (area) => dispatch(updateArea(area)),
    onGetUserGuilds: () => dispatch(getUserGuilds()),
    onCreateUserGuild: (guild) => dispatch(createUserGuild(guild)),
    onDeleteUserGuild: (id) => dispatch(deleteUserGuild(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PlantsGuild)
